import { render } from "./ReportOrderStatusByTime.vue?vue&type=template&id=db706dcc&scoped=true"
import script from "./ReportOrderStatusByTime.vue?vue&type=script&lang=js"
export * from "./ReportOrderStatusByTime.vue?vue&type=script&lang=js"

import "./ReportOrderStatusByTime.vue?vue&type=style&index=0&id=db706dcc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-db706dcc"

export default script